import { render, staticRenderFns } from "./PriceChange.vue?vue&type=template&id=5d4ebe2f&scoped=true&"
import script from "./PriceChange.vue?vue&type=script&lang=js&"
export * from "./PriceChange.vue?vue&type=script&lang=js&"
import style0 from "./PriceChange.vue?vue&type=style&index=0&id=5d4ebe2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ebe2f",
  null
  
)

export default component.exports